import { makeStyles } from '@mui/styles';

const styles = makeStyles((theme) => {
  return {
    searchBar: {
      backgroundColor: 'transparent',
      width: '100%',
      marginRight: '1vh',
      '&.MuiFilledInput-root:hover': {
        backgroundColor: 'transparent',
      },
      '&.MuiInputBase-root :hover': {
        backgroundColor: 'transparent',
      },
      fontSize: 'larger',
    },
    dateTimePicker: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      alignSelf: 'flex-start',
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    dateContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    aspectRatioContainer: {
      marginLeft: '-10px',
    },
    runActionContainer: {
      marginLeft: '-8px'
    }
  };
});

export default styles;
